module.exports = __webpack_public_path__ + "img/pete-display.c57d1a7f.png";